var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3665 8.60016V11.4002C11.3665 13.7335 10.4332 14.6668 8.09987 14.6668H5.29987C2.96654 14.6668 2.0332 13.7335 2.0332 11.4002V8.60016C2.0332 6.26683 2.96654 5.3335 5.29987 5.3335H8.09987C10.4332 5.3335 11.3665 6.26683 11.3665 8.60016Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1 1.3335H9.30004C7.00004 1.3335 6.06671 2.24683 6.04004 4.50016H8.10004C10.9 4.50016 12.2 5.80016 12.2 8.60016V10.6602C14.4534 10.6335 15.3667 9.70016 15.3667 7.40016V4.60016C15.3667 2.26683 14.4334 1.3335 12.1 1.3335Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.0e84f4c71b2506c04119139b69f040cb.svg";
export { ForwardRef as ReactComponent };